<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">
              <div class="title-action">
                <router-link
                  class="no-underline mr-2"
                  :to="`/schedules-monthly`">
                  <i class="fas fa-chevron-left"></i>
                </router-link>
              </div>
              <div class="header-container">
                <div class="title-header">
                  สร้างผังเดือนใหม่
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!isValid"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <SectionScheduleMonthlyInformation
          :schedule.sync="schedule"
          :saveScheduleStateError.sync="saveScheduleState.error"/>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/layouts/Page.vue';
import { addSchedule } from './api';
import SectionScheduleMonthlyInformation from './SectionScheduleMonthlyInformation.vue';

export default {
  components: {
    Page,
    SectionScheduleMonthlyInformation,
  },
  data() {
    return {
      schedule: {
        name: '',
        shortName: '',
        startPublish: '',
        endPublish: '',
        status: 'draft',
        image: null,
        imagePlain: null,
        pdf: null,
      },
      saveScheduleState: {
        isSaving: false,
        isSaved: false,
        error: {
          name: null,
        },
      },
      errorStatus: null,
    };
  },
  computed: {
    isValid() {
      return this.schedule.name;
    },
  },
  methods: {
    async onSubmit() {
      this.saveScheduleState.isSaving = true;
      try {
        const scheduleMonthly = await addSchedule(this.schedule);
        this.schedule = scheduleMonthly.data;
        this.saveScheduleState.isSaving = false;
        this.errorStatus = null;
        this.$router.push('/schedules-monthly');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveScheduleState.error = error.response.data;
        this.saveScheduleState.isSaving = false;
      }
    },
    isServerError() {
      return this.errorStatus;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500 && errorStatus === 404) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422) {
        return 'กรอกข้อมูลไม่ถูกต้อง กรุณาตรวจสอบและกรอกข้อมูลอีกครั้ง';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
